'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.More = void 0;
const $ = require("jquery");
class More {
    constructor() {
        $('.trigMoreNews').on('click', (e) => {
            const number = parseInt($(e.currentTarget).attr('data-number'));
            const category = $(e.currentTarget).attr('data-category');
            // 各番号に応じた要素の範囲を計算
            const start = number * 6;
            const end = start + 5;
            // 指定された範囲の要素を表示
            $(`.bulletMoreNews[data-category="${category}"]`).each((index, element) => {
                if (index >= start && index <= end) {
                    $(element).attr('data-is-show', 'true');
                }
            });
            // index番号が異なるので、endに＋1する
            //.bulletMoreNewsの数が(end + 1)より小さければ「もっと見るボタン」を隠す
            if ((end + 1) >= $(`.bulletMoreNews[data-category="${category}"]`).length) {
                $(e.currentTarget).hide();
            }
            else {
                //.bulletMoreNewsの数が(end + 1)より大きければnumberに+1
                const nextNumber = number + 1;
                $(e.currentTarget).attr('data-number', nextNumber);
            }
        });
    }
}
exports.More = More;
exports.default = More;
